module.exports = __webpack_public_path__ + "static/media/celegence.4b94b4fd.svg";